module.exports = __webpack_public_path__ + "8281674fd6308c1c9fc69f60c7a21c4d.jpg";